/*
 * @Author: dengxy 1148926496@qq.com
 * @Date: 2024-12-20 11:08:12
 * @LastEditors: dengxy 1148926496@qq.com
 * @LastEditTime: 2025-08-13 09:58:29
 * @FilePath: \frontend\src\store\modules\user.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getPublicKey, login, logout, getInfo } from '@/api/upms'
import { encrypt } from '@/utils/jsencrypt'
import { getToken, setToken, removeToken } from '@/utils/auth'
import defAva from '@/assets/logo/logo.png'

const useUserStore = defineStore(
  'user',
  {
    state: () => ({
      token: getToken(),
      id: '',
      name: '',
      avatar: defAva,
      roles: [],
      permissions: [],
      isLogin: false
    }),
    actions: {
      // 登录
      async login(userInfo) {
        const publicKeyRes = await getPublicKey()
        const { data: publicKey } = publicKeyRes
        const username = userInfo.username.trim()
        const mix = encrypt(userInfo.password, publicKey)
        return new Promise((resolve, reject) => {
          login({ username, mix }).then(res => {
            setToken(res.data)
            this.token = res.data
            resolve()
          }).catch(error => {
            reject(error)
          })
        })
      },
      // 获取用户信息
      getInfo() {
        return new Promise((resolve, reject) => {
          getInfo().then(res => {
            // console.log('res', res)
            const user = res.data.user
            const avatar = (user.avatar == "" || user.avatar == null) ? defAva : import.meta.env.VITE_APP_BASE_API + user.avatar;
            if (user.roles && user.roles.length > 0) { // 验证返回的roles是否是一个非空数组
              this.roles = user.roles
              this.permissions = res.data.permissions
            } else {
              this.roles = ['ROLE_DEFAULT']
            }
            this.name = user.username
            this.avatar = avatar;
            this.isLogin = true
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        })
      },
      // 退出系统
      logOut() {
        return new Promise((resolve, reject) => {
          // logout().then(() => {
          //   this.token = ''
          //   this.roles = []
          //   this.permissions = []
          //   this.isLogin = false
          //   removeToken()
          //   resolve()
          // }).catch(error => {
          //   reject(error)
          // })
          this.token = ''
          this.roles = []
          this.permissions = []
          this.isLogin = false
          removeToken()
          resolve()
        })
      }
    }
  })

export default useUserStore
